import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';

const ProgramAndDigest = () => {
  const theme = useTheme();

  return (
    <Box marginBottom={4}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Estrategia
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        Programas ancla e idea disruptiva
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2.5,
              height: '100%',
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
            }}
          >
            <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom>
              Programa ancla
            </Typography>
            <Typography variant="h6" gutterBottom>
              TNO Business
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
              Chemical se instala en el espacio de negocios y desarrollo de TNO: credibilidad, tono profesional y
              audiencia con intención de crecer.
            </Typography>
            <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom sx={{ mt: 2 }}>
              La Hora del Emprendedor Chemical
            </Typography>
            <Typography variant="body2" color="textSecondary">
              En lugar de un comercial tradicional, una <strong>mini-mentoría en vivo</strong>: el representante de
              Chemical explica cómo montar un negocio de productos de limpieza con baja inversión, pasos claros y
              llamado a la acción. Contenido que educa y convierte en prospectos.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2.5,
              height: '100%',
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
            }}
          >
            <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom>
              Programa ancla
            </Typography>
            <Typography variant="h6" gutterBottom>
              Franquicias en Venezuela
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
              El ecosistema de referencia en TNO para <strong>modelos de negocio escalables</strong>, con audiencia B2B:
              inversionistas, gerencia y emprendedores que buscan oportunidades replicables —el mismo perfil que
              necesita Chemical para su red de distribución.
            </Typography>
            <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom sx={{ mt: 2 }}>
              Qué aporta Chemical aquí
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Segmentos o entrevistas donde la marca presenta la <strong>distribución como negocio</strong>: estructura,
              márgenes, territorios y acompañamiento. Se conecta con la tesis del programa —escalabilidad y
              estandarización— sin forzar un formato de franquicia que no aplique: la narrativa es oportunidad de negocio
              seria con respaldo Chemical.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              p: 2.5,
              height: '100%',
              borderRadius: 2,
              border: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
            }}
          >
            <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom>
              TNO Digest (SEO)
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
              <strong>Siempre 4 artículos al mes</strong> en TNO Digest: piezas orientadas a búsqueda y conversión, con
              CTA directo a WhatsApp para solicitar el plan de distribuidor. Compromiso mensual fijo, no sujeto a
              cupos variables.
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{
                fontStyle: 'italic',
                p: 1.5,
                borderRadius: 1,
                bgcolor: theme.palette.mode === 'dark' ? 'background.paper' : 'grey.100',
              }}
            >
              Ejemplo de línea editorial: «5 razones por las que el sector de limpieza es la inversión más segura en
              2026»
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
              Las piezas incluyen <strong>botón de WhatsApp</strong> visible: «Solicitar plan de distribuidor» —tráfico
              orgánico que aterriza en conversación comercial.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProgramAndDigest;
